import { render, staticRenderFns } from "./orgStrut.vue?vue&type=template&id=51dd5856&scoped=true&"
import script from "./orgStrut.vue?vue&type=script&lang=js&"
export * from "./orgStrut.vue?vue&type=script&lang=js&"
import style0 from "./orgStrut.vue?vue&type=style&index=0&id=51dd5856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd5856",
  null
  
)

export default component.exports